{
  "brand": "First-run setup",
  "progress": {
    "account": "Account",
    "school": "School",
    "email": "Email",
    "finish": "Finish"
  },
  "account": {
    "title": "Welcome to Cadence",
    "subtitle": "Let's set up your school. First, name it and create your administrator account.",
    "schoolName": "School name",
    "schoolNamePlaceholder": "e.g. Riverside Dance Academy",
    "firstName": "First name",
    "lastName": "Last name",
    "email": "Email address",
    "password": "Password",
    "confirmPassword": "Confirm password",
    "weak": "Password must be at least 8 characters.",
    "mismatch": "Passwords do not match.",
    "submit": "Create account & continue"
  },
  "school": {
    "title": "School details",
    "subtitle": "Set your currency, time zone and language. You can change all of this later in Settings.",
    "currency": "Primary currency",
    "currencyHint": "Your school's main currency — fees are charged in it and all payments, income and reports are totalled in it. You can add more currencies and change this later in Settings.",
    "timezone": "Time zone",
    "language": "Default language",
    "contactEmail": "Contact email",
    "save": "Save & continue"
  },
  "email": {
    "title": "Email delivery",
    "subtitle": "Configure an email provider so you can invite teachers and students and send password resets. You can skip this and set it up later.",
    "provider": "Provider",
    "apiKey": "API key",
    "fromAddress": "From address",
    "fromName": "From name (optional)",
    "keyPrefixHint": "Key should start with \"{prefix}\".",
    "noMasterKey": "Email keys are stored encrypted. Set the ENCRYPTION_KEY Worker secret before saving a key — until then, skip this step and configure email later in Settings.",
    "save": "Save & continue"
  },
  "finish": {
    "title": "You're all set",
    "subtitle": "Your school is ready. Here are a few optional next steps — all available any time from the menu.",
    "addTeachers": "Add teachers",
    "addTeachersBody": "Invite teachers and give them login access.",
    "addStudents": "Add students",
    "addStudentsBody": "Create students and send onboarding links.",
    "configureFees": "Set up billing",
    "configureFeesBody": "Define fees, price tiers and payment methods.",
    "features": "Features",
    "featuresBody": "Turn optional modules on or off.",
    "go": "Finish & go to dashboard"
  },
  "skip": "Skip for now"
}
